import { render, staticRenderFns } from "./SearchResultPQ.vue?vue&type=template&id=49e38794&"
import script from "./SearchResultPQ.vue?vue&type=script&lang=js&"
export * from "./SearchResultPQ.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports